import { render, staticRenderFns } from "./cityList.vue?vue&type=template&id=4004c561&scoped=true"
import script from "./cityList.vue?vue&type=script&lang=js"
export * from "./cityList.vue?vue&type=script&lang=js"
import style0 from "./cityList.vue?vue&type=style&index=0&id=4004c561&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4004c561",
  null
  
)

export default component.exports